export const SET_HIDE_LIBRARY = 'SET_HIDE_LIBRARY';

export const SET_IS_NFR_MARKET = 'SET_IS_NFR_MARKET';

export const SET_FIRST_NAME = 'SET_FIRST_NAME';

export const SET_SELECTED_COUNTRY = 'SET_SELECTED_COUNTRY';

export const SET_IS_AR_MARKET = 'SET_IS_AR_MARKET';

export const SET_IS_VAULT_MARKET = 'SET_IS_VAULT_MARKET';

export const SET_LOGIN_AGAIN ='SET_LOGIN_AGAIN';

export const SET_IS_LOADING = 'SET_IS_LOADING';

export const SET_CATALOG_TYPE = 'SET_CATALOG_TYPE';

export const SET_CATALOG_NAME = 'SET_CATALOG_NAME';

export const RESET = 'RESET';

export const SET_CUSTOMER_TYPE = 'SET_CUSTOMER_TYPE';

export const SET_LAST_COMPLETED_STEP = 'SET_LAST_COMPLETED_STEP';



// WEBPACK FOOTER //
// ./src/store/actions/types/appActionTypes.js